/**
 * ダッシュボード画面画面の画像ロック解除クラス
 *
 * @export ReleaseImageLock
 * @class ReleaseImageLock
 */
export class ReleaseImageLock {
  /** 処理名 */
  processName: string = String('');
  /** ユーザID */
  userId: string = String('');
  /** 画像ロックエラー情報 */
  UnlockedInfo: { Image: [] }
}
